import { SITE } from "@/constants/testIds";
import { BulletList } from "@/components/site/BulletList";

/** Strengths + Risks two-column panels on the report page. */
export function ReportHighlightPanels({ strengths, risks }) {
  if (strengths.length === 0 && risks.length === 0) return null;
  return (
    <div className="grid md:grid-cols-2 gap-4 mb-6">
      {strengths.length > 0 && (
        <div data-testid={SITE.reportStrengths} className="rounded-xl border border-kira-border bg-kira-surface p-6">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-kira-gold mb-4">
            Strengths
          </p>
          <BulletList items={strengths} tone="gold" />
        </div>
      )}
      {risks.length > 0 && (
        <div data-testid={SITE.reportRisks} className="rounded-xl border border-kira-border bg-kira-surface p-6">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-market-sell mb-4">
            Risks
          </p>
          <BulletList items={risks} tone="red" />
        </div>
      )}
    </div>
  );
}

/** Legacy "Key Highlights" panel — rendered after the metrics grid. */
export function ReportKeyHighlights({ highlights }) {
  if (highlights.length === 0) return null;
  return (
    <div data-testid={SITE.reportHighlights} className="rounded-xl border border-kira-border bg-kira-surface p-6 mb-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-kira-gold mb-4">
        Key Highlights
      </p>
      <BulletList items={highlights} tone="gold" />
    </div>
  );
}

